import Crud from '../views/ProjectType/Crud'
import Entity from '../views/ProjectType/Add'


let routes = {
    path: '/project_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/project_types/add',
            name: 'NewProjectType',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de sistema',
                breadcrumb: [
                    {
                        text: 'Tipos de sistema',
                        active: false,
                        to: '/project_types',
                    },
                    {
                        text: 'Adicionar tipo de sistema',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/project_types/edit/:id?',
            name: 'EditProjectType',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de sistema',
                breadcrumb: [
                    {
                        text: 'Tipos de sistema',
                        active: false,
                        to: '/project_types',
                    },
                    {
                        text: 'Editar tipo de sistema',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/project_types',
            name: 'list-project_types',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Tipos de sistema',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
